import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPodcast2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPodcast2"><Path d="M8.5 11C8.5 9.067 10.067 7.5 12 7.5C13.933 7.5 15.5 9.067 15.5 11V14C15.5 15.933 13.933 17.5 12 17.5C10.067 17.5 8.5 15.933 8.5 14V11Z" stroke="currentColor"/><Path d="M18.7175 18.7175C22.4275 15.0075 22.4275 8.99247 18.7175 5.28249C15.0075 1.5725 8.99247 1.5725 5.28249 5.28249C1.5725 8.99247 1.5725 15.0075 5.28249 18.7175" stroke="currentColor"/><Path d="M12 17.5V20.5" stroke="currentColor"/><Path d="M9 20.5H15" stroke="currentColor"/></CentralIconBase>;
});

export default IconPodcast2;
